import gql from 'graphql-tag';
import { mutation } from 'services/graphql';

export const collaboratingUserEnteredSurfaceMutation = gql`
  mutation collaboratingUserEnteredSurface(
    $input: CollaboratingUserEnteredSurfaceInput!
  ) {
    collaboratingUserEnteredSurface(input: $input)
  }
`;

export default mutation(collaboratingUserEnteredSurfaceMutation);
